import React from 'react';
import { Row, Col } from 'reactstrap';
import { renderHTMLContent } from '../../../../common/function';

const ViewEssayQuestions = (props) => {
  const {
    development_justification = '',
    setJustification,
    question,
    is_multiple,
    is_development,
    justification1 = '',
    displayError,
    setUserChoice,
    selectedIndex,
    userChoice,
    justification,
    disabledTextArea,
    // clickOption,
    selectedCaseQuestionData,
    // disabledChoices,
  } = props;
  let choices = [];
  for (const objKey in props)
    if (objKey.includes('choice')) if (props[objKey]) choices.push(props[objKey]);

  return (
    <Col xs='12' sm='12' lg='12' className='pb-2'>
      {renderHTMLContent(
        question,
        "div",
        "text-justify view_questionhtml margin_bottom_20"
      )}
      <Row>
        {development_justification.includes('&;') ? (
          <Col className={`border-gray rounded p-1`} md='12' xs='12' sm='12'>
            <b>{development_justification.split('&;')[0].split(':')[0]} :</b>
            <input
              type='text'
              className='w-50 view_questionhtml'
              placeholder='Please write your answer'
            />
          </Col>
        ) : null}
        {choices.length || development_justification.includes('&;') ? (
          <Col xs='12' md={development_justification.includes('&;') ? '12' : '3'}>
            <div
              className={`flex-column  d-flex border border-gray rounded mb-sm-1 mb-md-0 ${
                development_justification.includes('&;') ? 'justify-content-around' : 'flex-column'
              }  d-flex border ${
                is_multiple ? 'border-gray rounded mb-sm-1 mb-md-0 question_sidebar' : ''
              } `}
            >
              {choices.map((choice, index) => (
                <div
                  // className={`${
                  //   userChoice[selectedCaseQuestionData.id] ===
                  //   `choice_${String.fromCharCode(index + 97)}`
                  //     ? `border-yellow`
                  //     : 'border-black'
                  // }`}
                  key={index}
                  className={`d-flex align-items-center pointer_class sidebar_item ${
                    is_multiple ? '' : 'h-100p '
                  } ${
                    selectedIndex === index ||
                    (selectedIndex === -1 &&
                      userChoice[selectedCaseQuestionData.id] ===
                        `choice_${String.fromCharCode(index + 97)}`)
                      ? 'clicked_box_bg_yellow'
                      : ''
                  }`}
                  name='selectedChoice'
                  onClick={() => setUserChoice(choice, index)}
                >
                  <span>{choice}</span>
                </div>
              ))}
            </div>
          </Col>
        ) : null}
        <Col
          xs='12'
          md={
            development_justification.includes('&;') || (is_development && !choices.length)
              ? '12'
              : '9 pl-md-0'
          }
          className={`${
            development_justification.includes('&;') || (is_development && !choices.length)
              ? ''
              : ''
          } `}
        >
          {is_development ? (
            is_multiple ? (
              <textarea
                className='w-100 h-100 view_questionhtml'
                placeholder='Write your justification here'
                onChange={(e) => {
                  setJustification(e);
                }}
                disabled={disabledTextArea}
                value={
                  justification1 ||
                  (justification[selectedCaseQuestionData.id] &&
                    justification[selectedCaseQuestionData.id]['justification1']) ||
                  ''
                }
                name='justification1'
              />
            ) : choices.length ? (
              choices.map((choice, index) => (
                <div className='h-100p'>
                  <textarea
                    placeholder='Write your justification here'
                    className='w-100 h-100 view_questionhtml'
                    onChange={(e) => {
                      setJustification(e);
                    }}
                    disabled={disabledTextArea}
                    value={
                      props[`justification${index + 1}`] ||
                      (justification[selectedCaseQuestionData.id] &&
                        justification[selectedCaseQuestionData.id][`justification${index + 1}`]) ||
                      ''
                    }
                    name={[`justification${index + 1}`]}
                  />
                </div>
              ))
            ) : (
              <textarea
                className='w-100 h-100 min-height-150 view_questionhtml'
                placeholder='Write your justification here'
                onChange={(e) => {
                  setJustification(e);
                }}
                disabled={disabledTextArea}
                value={
                  justification1 ||
                  (justification[selectedCaseQuestionData.id] &&
                    justification[selectedCaseQuestionData.id]['justification1']) ||
                  ''
                }
                name='justification1'
              />
            )
          ) : null}
        </Col>
      </Row>
      {displayError ? (
        <h6 className='text-danger mt-1 mb-0'>
          Please make sure to enter your answer in the answer box before validating.
        </h6>
      ) : null}
    </Col>
  );
};

export default ViewEssayQuestions;



// WEBPACK FOOTER //
// ./src/views/CBT/CFA3CBT/Questions/ViewEssayQuestions.jsx